import React from 'react';
import PropTypes from 'prop-types';
import { setPropTypes } from 'recompose';

const SiblingWrapper = ({ container, children, ...props }) =>
  container ? React.createElement('div', props, children) : children;

export default setPropTypes({
  container: PropTypes.bool,
})(SiblingWrapper);
